// 教务管理-授课进度
const routes = [
  {
    path: '/teachingProgress',
    name: 'teachingProgress',
    meta: {
      title: '授课进度',
      volcengine: true,
    },
    component: () => import('@/pages/teachingProgress/index.vue')
  },
  {
    path: '/teachingProgress/bookClassDetail',
    name: 'teachingProgress/bookClassDetail',
    meta: {
      title: '约课进度详情',
      volcengine: true,
    },
    component: () => import('@/pages/teachingProgress/components/bookClassDetail.vue')
  },
  {
    path: '/teachingProgress/studentbookClassDetail',
    name: 'teachingProgress/studentbookClassDetail',
    meta: {
      title: '约课进度详情',
      volcengine: true,
    },
    component: () => import('@/pages/teachingProgress/components/studentbookClassDetail.vue')
  },

]

export default routes